export const legalPages = {
  hi: {
    privacy: {
      title: 'गोपनीयता नीति',
      updated: 'अंतिम अपडेट: 8 अगस्त 2026',
      sections: [
        {
          heading: '1. परिचय',
          body: 'BRAHMOID Pvt. Ltd. ("BRAHMOID", "हम", "हमारा") आपकी गोपनीयता का सम्मान करती है। यह गोपनीयता नीति बताती है कि जब आप हमारी वेबसाइट brahmoid.org और संबंधित प्लेटफ़ॉर्म/ऐप का उपयोग करते हैं, तो हम आपकी जानकारी कैसे एकत्र, उपयोग, साझा और सुरक्षित करते हैं। यह नीति उम्मीदवार पंजीकरण, MLA/प्रायोजक पूछताछ, और हाइपरलोकल सोशल प्लेटफ़ॉर्म उपयोगकर्ताओं पर लागू होती है।',
        },
        {
          heading: '2. हम कौन-सी जानकारी एकत्र करते हैं',
          body: '',
          list: [
            'उम्मीदवार पंजीकरण डेटा: नाम, आयु, शिक्षा, मोबाइल नंबर, ईमेल, राज्य, ज़िला, पंचायत/गांव का नाम, और वैकल्पिक सामाजिक/सामुदायिक कार्य अनुभव।',
            'प्रायोजक / MLA पूछताछ डेटा: नाम, राजनीतिक दल/संगठन, पद, क्षेत्र विवरण, संपर्क जानकारी, और कार्यक्रम में रुचि संबंधी संदेश।',
            'हाइपरलोकल प्लेटफ़ॉर्म उपयोगकर्ता डेटा: KYC/पहचान दस्तावेज़, भूमिका (नागरिक, अधिकारी, ठेकेदार आदि), शिकायत विवरण (मुद्दा, स्थान, फ़ोटो/संलग्नक), पारदर्शिता लेजर हेतु लेन-देन जानकारी, और गतिविधि लॉग (रेटिंग, पोस्ट)।',
            'स्वतः एकत्र डेटा: IP पता, डिवाइस/ब्राउज़र जानकारी, और कुकी-आधारित उपयोग डेटा।',
          ],
        },
        {
          heading: '3. हम आपकी जानकारी का उपयोग कैसे करते हैं',
          list: [
            'उम्मीदवार चयन प्रक्रिया (परीक्षा, साक्षात्कार, सार्वजनिक बहस) चलाने हेतु',
            'प्रायोजन/कार्यक्रम अनुरोधों का मूल्यांकन और प्रबंधन',
            'स्थानीय शिकायतों को सही अधिकारी तक रूट करना और एस्केलेट करना',
            'पारदर्शिता लेजर, प्रोजेक्ट रजिस्ट्री, और जवाबदेही स्कोर बनाए रखना',
            'लीडर डैशबोर्ड और AI-आधारित समग्र ट्रेंड प्रदान करना',
            'प्लेटफ़ॉर्म सुरक्षा, धोखाधड़ी रोकथाम, और कानूनी अनुपालन',
          ],
        },
        {
          heading: '4. जानकारी किसके साथ साझा की जाती है',
          list: [
            'निर्वाचित प्रतिनिधि/पंचायत अधिकारी — शिकायत निवारण हेतु',
            'प्रायोजक — केवल कार्यक्रम प्रगति/परिणाम (सीमित)',
            'सेवा प्रदाता — होस्टिंग, एनालिटिक्स (जैसे Google Analytics), भुगतान प्रोसेसिंग — गोपनीयता व डेटा-प्रोसेसिंग समझौतों के तहत',
            'कानून प्रवर्तन / सरकारी एजेंसियां — केवल वैध कानूनी आवश्यकता (समन, अदालती आदेश) होने पर',
          ],
          body: 'हम आपका व्यक्तिगत डेटा किसी तीसरे पक्ष को विज्ञापन या मार्केटिंग उद्देश्यों हेतु नहीं बेचते।',
        },
        {
          heading: '5. डेटा सुरक्षा',
          body: 'हम उचित तकनीकी व संगठनात्मक सुरक्षा उपाय अपनाते हैं — जिनमें एन्क्रिप्शन, भूमिका-आधारित एक्सेस नियंत्रण, और ऑडिट ट्रेल शामिल हैं — विशेष रूप से पहचान व वित्तीय डेटा हेतु। फिर भी, इंटरनेट पर डेटा ट्रांसमिशन की 100% सुरक्षा की गारंटी नहीं दी जा सकती।',
        },
        {
          heading: '6. डेटा प्रतिधारण',
          body: 'हम आपकी जानकारी तब तक रखते हैं जब तक यह उस उद्देश्य हेतु आवश्यक है जिसके लिए एकत्र की गई थी, या जब तक कानून द्वारा अपेक्षित हो। पारदर्शिता लेजर से जुड़ा सार्वजनिक डेटा (जैसे लेन-देन रिकॉर्ड) पारदर्शिता के मकसद से लंबे समय तक सार्वजनिक रखा जा सकता है।',
        },
        {
          heading: '7. आपके अधिकार',
          body: 'Digital Personal Data Protection Act, 2023 (DPDP Act) व लागू कानूनों के अंतर्गत, आपको ये अधिकार प्राप्त हैं:',
          list: [
            'अपने डेटा तक पहुंच (access) का अनुरोध करने का अधिकार',
            'गलत या अधूरी जानकारी सुधारने (correction) का अधिकार',
            'सहमति वापस लेने या डेटा हटाने (erasure) का अनुरोध करने का अधिकार — जहां कानूनी रूप से लागू हो (सार्वजनिक पारदर्शिता रिकॉर्ड पर अपवाद लागू हो सकते हैं)',
            'शिकायत निवारण अधिकारी से संपर्क करने व शिकायत दर्ज करने का अधिकार',
          ],
        },
        {
          heading: '8. बच्चों की गोपनीयता',
          body: 'यह प्लेटफ़ॉर्म 18 वर्ष से कम आयु के व्यक्तियों के लिए नहीं है। हम जानबूझकर नाबालिगों से डेटा एकत्र नहीं करते। यदि हमें पता चलता है कि किसी नाबालिग का डेटा अनजाने में एकत्र हुआ है, तो हम उसे हटा देंगे।',
        },
        {
          heading: '9. नीति में बदलाव',
          body: 'हम इस नीति को समय-समय पर अपडेट कर सकते हैं। बड़े बदलावों की सूचना वेबसाइट पर स्पष्ट रूप से दी जाएगी।',
        },
        {
          heading: '10. संपर्क व शिकायत निवारण अधिकारी',
          body: 'नाम: Anurag\nईमेल: support@brahmoid.org\nपता: Chaar Murti, A-905, Tower T3, NXONE Business Tower, Plot No. 17, near Gaur Chowk, Tech Zone IV, Greater Noida, Uttar Pradesh 201318',
        },
      ],
    },
    cookie: {
      title: 'कुकी नीति',
      updated: 'अंतिम अपडेट: 8 अगस्त 2026',
      sections: [
        {
          heading: '1. कुकीज़ क्या हैं',
          body: 'कुकीज़ छोटी टेक्स्ट फ़ाइलें हैं जो वेबसाइट विज़िट के दौरान आपके डिवाइस (ब्राउज़र) पर संग्रहीत होती हैं। यह वेबसाइट को आपकी प्राथमिकताएं याद रखने और उपयोग को बेहतर समझने में मदद करती हैं।',
        },
        {
          heading: '2. हम किस प्रकार की कुकीज़ का उपयोग करते हैं',
          list: [
            'आवश्यक कुकीज़: वेबसाइट के बुनियादी कार्यों (लॉगिन सत्र, फ़ॉर्म सबमिशन, सुरक्षा) हेतु ज़रूरी। इन्हें बंद नहीं किया जा सकता क्योंकि इनके बिना प्लेटफ़ॉर्म काम नहीं करेगा।',
            'एनालिटिक्स कुकीज़: जैसे Google Analytics (GA4) — यह समझने हेतु कि विज़िटर वेबसाइट का उपयोग कैसे करते हैं, कौन-से पेज लोकप्रिय हैं, और अनुभव कैसे बेहतर किया जा सकता है।',
            'फ़ंक्शनल कुकीज़: भाषा प्राथमिकता व अन्य सेटिंग्स याद रखने हेतु।',
            'मार्केटिंग/ट्रैकिंग कुकीज़ (यदि लागू हो): प्रचार अभियानों (जैसे चुनाव प्रचार सामग्री) के प्रदर्शन को मापने हेतु।',
          ],
        },
        {
          heading: '3. तीसरे पक्ष की कुकीज़',
          body: 'हम Google Analytics जैसी बाहरी सेवाओं का उपयोग करते हैं, जो अपनी स्वयं की कुकीज़ सेट कर सकती हैं। इन सेवाओं की अपनी गोपनीयता व कुकी नीतियां अलग से लागू होती हैं — कृपया संबंधित सेवा प्रदाता की नीति भी देखें।',
        },
        {
          heading: '4. कुकीज़ कैसे प्रबंधित करें',
          body: 'आप अपने ब्राउज़र सेटिंग्स के माध्यम से कुकीज़ ब्लॉक, डिलीट या प्रबंधित कर सकते हैं। ध्यान दें कि आवश्यक कुकीज़ ब्लॉक करने से वेबसाइट की कार्यक्षमता प्रभावित हो सकती है।',
        },
        {
          heading: '5. सहमति',
          body: 'वेबसाइट पर पहली बार आने पर एक कुकी सहमति बैनर दिखाया जाएगा, जहां आप आवश्यक कुकीज़ के अलावा अन्य कुकीज़ को स्वीकार या अस्वीकार कर सकते हैं।',
        },
      ],
    },
    terms: {
      title: 'उपयोग की शर्तें',
      updated: 'अंतिम अपडेट: 8 अगस्त 2026',
      sections: [
        {
          heading: '1. स्वीकृति',
          body: 'इस प्लेटफ़ॉर्म का उपयोग करके, आप इन शर्तों से सहमत होते हैं। यदि आप सहमत नहीं हैं, तो कृपया प्लेटफ़ॉर्म का उपयोग न करें।',
        },
        {
          heading: '2. सेवा का विवरण',
          body: 'BRAHMOID Pvt. Ltd. दो मुख्य सेवाएं प्रदान करती है: (क) नेतृत्व विकास कार्यक्रम — योग्यता-आधारित उम्मीदवारों की पहचान और समर्थन; (ख) हाइपरलोकल सोशल प्लेटफ़ॉर्म — जनप्रतिनिधियों की जवाबदेही सुनिश्चित करने वाला डिजिटल मंच।',
        },
        {
          heading: '3. पात्रता',
          list: [
            'उम्मीदवार पंजीकरण पंचायत चुनाव नियमों के अनुसार आयु/शिक्षा आदि की पात्रता पर आधारित है।',
            'प्रायोजन कार्यक्रम कानूनी दिशानिर्देशों के अंतर्गत होना चाहिए।',
            'सामान्य प्लेटफ़ॉर्म उपयोगकर्ता 18 वर्ष या उससे अधिक आयु के होने चाहिए।',
          ],
        },
        {
          heading: '4. उम्मीदवार चयन प्रक्रिया — कोई गारंटी नहीं',
          body: 'पंजीकरण चयन की गारंटी नहीं देता। चयन परीक्षा, साक्षात्कार, और सामुदायिक भागीदारी पर आधारित है। BRAHMOID चुनाव परिणामों की गारंटी नहीं देता।',
        },
        {
          heading: '5. प्रायोजन कार्यक्रम की शर्तें',
          body: 'निवेश राशि और भुगतान अनुसूची अलग समझौतों में निर्दिष्ट होती है। BRAHMOID राजनीतिक लाभ या विशिष्ट परिणामों की गारंटी नहीं देता।',
        },
        {
          heading: '6. उपयोगकर्ता आचरण',
          list: [
            'झूठी जानकारी प्रदान न करें',
            'प्लेटफ़ॉर्म का दुरुपयोग न करें',
            'सुरक्षा में छेड़छाड़ का प्रयास न करें',
            'शिकायत प्रणाली का दुरुपयोग न करें',
          ],
        },
        {
          heading: '7. बौद्धिक संपदा',
          body: 'वेबसाइट की सभी सामग्री — पाठ, डिज़ाइन, पद्धति (जैसे जवाबदेही स्कोर मॉडल) — BRAHMOID Pvt. Ltd. की संपत्ति है।',
        },
        {
          heading: '8. तीसरे पक्ष की जानकारी की सटीकता',
          body: 'डेटा सरकारी/पंचायत स्रोतों और सामुदायिक रिपोर्टिंग पर आधारित हो सकता है। हम सटीकता के लिए प्रयास करते हैं, परंतु इसकी गारंटी नहीं देते।',
        },
        {
          heading: '9. दायित्व की सीमा',
          body: 'BRAHMOID Pvt. Ltd. अप्रत्यक्ष या परिणामी क्षति के लिए उत्तरदायी नहीं होगी।',
        },
        {
          heading: '10. समाप्ति',
          body: 'शर्तों के उल्लंघन पर हम आपकी पहुंच निलंबित या समाप्त कर सकते हैं।',
        },
        {
          heading: '11. शासकीय कानून व क्षेत्राधिकार',
          body: 'ये शर्तें भारतीय कानूनों द्वारा शासित हैं। क्षेत्राधिकार गौतम बुद्ध नगर, उत्तर प्रदेश की अदालतों तक सीमित है।',
        },
        {
          heading: '12. शर्तों में बदलाव',
          body: 'हम इन शर्तों को किसी भी समय अपडेट कर सकते हैं।',
        },
        {
          heading: '13. संपर्क',
          body: 'प्रश्नों हेतु: support@brahmoid.org',
        },
      ],
    },
  },
  en: {
    privacy: {
      title: 'Privacy Policy',
      updated: 'Last updated: 8 August 2026',
      sections: [
        {
          heading: '1. Introduction',
          body: 'BRAHMOID Pvt. Ltd. ("BRAHMOID", "we", "our") respects your privacy. This Privacy Policy explains how we collect, use, share, and protect your information when you use our website brahmoid.org and related platforms/apps. It applies to candidate registration, MLA/sponsor inquiries, and hyperlocal social platform users.',
        },
        {
          heading: '2. Information we collect',
          list: [
            'Candidate registration data: name, age, education, mobile number, email, state, district, panchayat/village name, and optional social/community work experience.',
            'Sponsor / MLA inquiry data: name, political party/organization, role, constituency details, contact information, and program interest messages.',
            'Hyperlocal platform user data: KYC/identity documents, role (citizen, official, contractor, etc.), complaint details (issue, location, photos/attachments), transaction information for transparency ledgers, and activity logs (ratings, posts).',
            'Automatically collected data: IP address, device/browser information, and cookie-based usage data.',
          ],
        },
        {
          heading: '3. How we use your information',
          list: [
            'To run candidate selection processes (exams, interviews, public debates)',
            'To evaluate and manage sponsorship/program requests',
            'To route and escalate local complaints to the correct officials',
            'To maintain transparency ledgers, project registries, and accountability scores',
            'To provide leader dashboards and AI-based aggregate trends',
            'For platform security, fraud prevention, and legal compliance',
          ],
        },
        {
          heading: '4. Who we share information with',
          list: [
            'Elected representatives/Panchayat officials — for grievance resolution',
            'Sponsors — limited to program progress/results only',
            'Service providers — hosting, analytics (e.g. Google Analytics), payment processing — under privacy and data-processing agreements',
            'Law enforcement / government agencies — only upon valid legal requirement (summons, court orders)',
          ],
          body: 'We do not sell your personal data to third parties for advertising or marketing purposes.',
        },
        {
          heading: '5. Data security',
          body: 'We adopt appropriate technical and organizational security measures — including encryption, role-based access control, and audit trails — especially for identity and financial data. However, 100% security of data transmission over the internet cannot be guaranteed.',
        },
        {
          heading: '6. Data retention',
          body: 'We retain your information for as long as necessary for the purpose for which it was collected, or as required by law. Public data linked to transparency ledgers (such as transaction records) may be kept public for longer for transparency purposes.',
        },
        {
          heading: '7. Your rights',
          body: 'Under the Digital Personal Data Protection Act, 2023 (DPDP Act) and applicable laws, you have the right to:',
          list: [
            'Request access to your data',
            'Correct inaccurate or incomplete information',
            'Request erasure or withdraw consent — where legally applicable (exceptions may apply for public transparency records)',
            'Contact the grievance officer and lodge a complaint',
          ],
        },
        {
          heading: '8. Children\'s privacy',
          body: 'This platform is not intended for individuals under 18 years of age. We do not knowingly collect data from minors. If we learn that a minor\'s data was collected inadvertently, we will delete it.',
        },
        {
          heading: '9. Changes to this policy',
          body: 'We may update this policy from time to time. Significant changes will be clearly notified on the website.',
        },
        {
          heading: '10. Contact & Grievance Redressal Officer',
          body: 'Name: Anurag\nEmail: support@brahmoid.org\nAddress: Chaar Murti, A-905, Tower T3, NXONE Business Tower, Plot No. 17, near Gaur Chowk, Tech Zone IV, Greater Noida, Uttar Pradesh 201318',
        },
      ],
    },
    cookie: {
      title: 'Cookie Policy',
      updated: 'Last updated: 8 August 2026',
      sections: [
        {
          heading: '1. What are cookies',
          body: 'Cookies are small text files stored on your device (browser) during a website visit. They help the website remember your preferences and understand usage better.',
        },
        {
          heading: '2. Types of cookies we use',
          list: [
            'Essential cookies: Required for basic website functions (login sessions, form submission, security). These cannot be disabled as the platform will not work without them.',
            'Analytics cookies: Such as Google Analytics (GA4) — to understand how visitors use the website, which pages are popular, and how to improve the experience.',
            'Functional cookies: To remember language preferences and other settings.',
            'Marketing/tracking cookies (if applicable): To measure the performance of promotional campaigns (such as election campaign materials).',
          ],
        },
        {
          heading: '3. Third-party cookies',
          body: 'We use external services such as Google Analytics, which may set their own cookies. These services have their own privacy and cookie policies — please refer to the relevant service provider\'s policy as well.',
        },
        {
          heading: '4. How to manage cookies',
          body: 'You can block, delete, or manage cookies through your browser settings. Note that blocking essential cookies may affect website functionality.',
        },
        {
          heading: '5. Consent',
          body: 'On your first visit to the website, a cookie consent banner will be displayed where you can accept or reject non-essential cookies.',
        },
      ],
    },
    terms: {
      title: 'Terms of Use',
      updated: 'Last updated: 8 August 2026',
      sections: [
        {
          heading: '1. Acceptance',
          body: 'By using this platform, you agree to these terms. If you do not agree, please do not use the platform.',
        },
        {
          heading: '2. Description of services',
          body: 'BRAHMOID Pvt. Ltd. provides two main services: (a) Leadership Development Program — identifying and supporting merit-based candidates; (b) Hyperlocal Social Platform — a digital platform ensuring accountability of public representatives.',
        },
        {
          heading: '3. Eligibility',
          list: [
            'Candidate registration is subject to age/education eligibility per Panchayat election rules.',
            'Sponsorship programs must comply with legal guidelines.',
            'General platform users must be 18 years of age or older.',
          ],
        },
        {
          heading: '4. Candidate selection — no guarantee',
          body: 'Registration does not guarantee selection. Selection is based on exams, interviews, and community participation. BRAHMOID does not guarantee election outcomes.',
        },
        {
          heading: '5. Sponsorship program terms',
          body: 'Investment amounts and payment schedules are specified in separate agreements. BRAHMOID does not guarantee political gains or specific results.',
        },
        {
          heading: '6. User conduct',
          list: [
            'Do not provide false information',
            'Do not misuse the platform',
            'Do not attempt to tamper with security',
            'Do not misuse the grievance system',
          ],
        },
        {
          heading: '7. Intellectual property',
          body: 'All website content — text, design, methodology (such as the accountability score model) — is the property of BRAHMOID Pvt. Ltd.',
        },
        {
          heading: '8. Accuracy of third-party information',
          body: 'Data may be based on government/Panchayat sources and community reporting. While we strive for accuracy, we do not guarantee it.',
        },
        {
          heading: '9. Limitation of liability',
          body: 'BRAHMOID Pvt. Ltd. shall not be liable for indirect or consequential damages.',
        },
        {
          heading: '10. Termination',
          body: 'We may suspend or terminate your access for violations of these terms.',
        },
        {
          heading: '11. Governing law & jurisdiction',
          body: 'These terms are governed by the laws of India. Jurisdiction is limited to courts in Gautam Buddha Nagar, Uttar Pradesh.',
        },
        {
          heading: '12. Changes to terms',
          body: 'We may update these terms at any time.',
        },
        {
          heading: '13. Contact',
          body: 'For queries: support@brahmoid.org',
        },
      ],
    },
  },
};
